import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'RoundedCard',
  props: {
    color: {},
    noPadding: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full rounded p-m", {
      [`bg-white`]: props.color == null || props.color == 'white',
      [`bg-red-100`]: props.color == 'red',
      [`bg-blue-100`]: props.color == 'blue',
      [`bg-green-100`]: props.color == 'green',
      [`bg-yellow-100`]: props.color == 'yellow',
      [`bg-gray-100`]: props.color == 'gray',
      [`p-5`]: _ctx.noPadding == true,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})